import React from 'react'
import { useState } from 'react';

const MBikeModel = ({ onSelect }) => {
  const [formData, setFormData] = useState({
    searchTerm: "",
    selectedBikeModels: [],
  });

  const BikeModels = [
    "Royal Enfeilds",
    "Suzuki",
    "Koramangala (Beside Sony Signal)",
    "Majestic (Opp to POTHYS)",
    "Bellandur (Adarsh Palm Retreat)",
    "Hebbal (Presidency College)",
    "Bannerghatta Road",
    "BTM 2nd Stage",
    "Shivaji Nagar, Belgaum",
    "Tilakwadi, Belgaum",
    "Khanapur Road, Belgaum",
    "Vadgaon, Belgaum",
    "Ramteerth Nagar, Belgaum",
    "Angol, Belgaum",
  ];

  const handleSearch = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      searchTerm: e.target.value,
    }));
  };

  const toggleLocation = (location) => {
    setFormData((prevData) => {
      const updatedBikeModels = prevData.selectedBikeModels.includes(location)
        ? prevData.selectedBikeModels.filter((loc) => loc !== location)
        : [...prevData.selectedBikeModels, location];

      return {
        ...prevData,
        selectedBikeModels: updatedBikeModels,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSelect(formData.selectedBikeModels); // Pass selected BikeModels to parent
  };

  const filteredBikeModels = BikeModels.filter((location) =>
    location.toLowerCase().includes(formData.searchTerm.toLowerCase())
  );

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="p-6 bg-white rounded-md shadow-lg max-w-md w-full min-h-screen"
      >
        {/* Search Input */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search BikeModel"
            value={formData.searchTerm}
            onChange={handleSearch}
            className="w-full border rounded-md p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
          />
        </div>

        <div className="border rounded-md p-2">
          {filteredBikeModels.map((location, index) => (
            <div key={index} className="flex items-center justify-between py-2">
              <label htmlFor={`location-${index}`} className="text-sm text-gray-800">
                {location}
              </label>
              <input
                type="checkbox"
                id={`location-${index}`}
                checked={formData.selectedBikeModels.includes(location)}
                onChange={() => toggleLocation(location)}
                className="w-4 h-4 text-[#FF9630] border-gray-300 rounded focus:ring-[#FF9630]"
              />
            </div>
          ))}
        </div>

        {/* Buttons */}
        <div className="mt-12 flex space-x-4 ">
          <button
            type="button"
            onClick={() =>
              setFormData({
                searchTerm: "",
                selectedBikeModels: [],
              })
            }
            className="flex-1 py-2 text-[#FF9630] border border-[#FF9630] rounded-md font-medium"
          >
            Clear
          </button>
          <button
            type="submit"
            className="flex-1 py-2 bg-[#FF9630] text-white rounded-md font-medium"
          >
            Add to Filter
          </button>
        </div>
      </form>
    </div>
  );
};

export default MBikeModel